/** One-tap starters for contractors — label is plain language; prompt is what the AI receives.
 *
 *  Todo va como CLAVE, incluido `prompt`. Que el prompt siga el idioma no es un
 *  detalle: es la instrucción que recibe el modelo, así que de él depende en qué
 *  idioma CONTESTA. Con el prompt fijo en inglés, un contratista picaba un botón
 *  en español y le respondían en inglés.
 *
 *  Este archivo es un módulo, no un componente: quien lo pinta es el que traduce.
 */
import type { Clave } from '../../i18n/textos';

export interface RazaQuickPrompt {
  label: Clave;
  hint: Clave;
  prompt: Clave;
}

export const RAZA_QUICK_PROMPTS: RazaQuickPrompt[] = [
  { label: 'chat.rapido.hoy.etiqueta',     hint: 'chat.rapido.hoy.pista',     prompt: 'chat.rapido.hoy.prompt' },
  { label: 'chat.rapido.mensaje.etiqueta', hint: 'chat.rapido.mensaje.pista', prompt: 'chat.rapido.mensaje.prompt' },
  { label: 'chat.rapido.dinero.etiqueta',  hint: 'chat.rapido.dinero.pista',  prompt: 'chat.rapido.dinero.prompt' },
];

export const RAZA_WELCOME_TITLE: Clave = 'chat.bienvenida.titulo';
export const RAZA_WELCOME_BODY: Clave = 'chat.bienvenida.cuerpo';
export const RAZA_INPUT_PLACEHOLDER: Clave = 'chat.entrada.placeholder';
